import React, {useEffect, useState} from 'react';
import EStyleSheet from "react-native-extended-stylesheet";
import {HStack, Switch, VStack} from "native-base";
import {useDispatch, useSelector} from "react-redux";
import {updateScheduleSetting} from "../../../../../../../redux/ScheduleSlice";
import {isMobile} from "../../../../../../../services/Helpers";
import CustomSwitch from "../../../../../../common/CustomSwitch";
import AppText from "../../../../../../common/AppText";
import {GlobalStyleAttributes} from "../../../../../../../styles/GlobalStyles";
import {t} from "../../../../../../../services/i18n";
import { SCHEDULE_SETTINGS } from '../../../../../../../services/ConstHelper';

const QrNotification = (props) => {
    const { values, setFieldValue } = props;
    const box = useSelector((state) => state.box.box);
    const [isChecked, setIsChecked] = useState(!!values?.sendQrMessage);
    const dispatch = useDispatch()


    useEffect(() => {
        if(box) setIsChecked(!!(box.send_qr_messsage ?? box.settings?.[SCHEDULE_SETTINGS]?.send_qr_messsage))
    }, [box.settings?.[SCHEDULE_SETTINGS]]);

    const toggle = (val) => {
        const value = val ? true : false
        if(isMobile) dispatch(updateScheduleSetting({send_qr_messsage: value}))
        else {
            setFieldValue('sendQrMessage', value)
        }
        setIsChecked(val)
    }

    return (
        <>
            {isMobile ? <CustomSwitch isChecked={isChecked} onToggle={toggle} style={{ width: isMobile && 'inherit' }} />
            :
            <VStack space={'1rem'}>
                <HStack justifyContent={'space-between'} alignItems={'center'}>
                    <AppText fontSize={GlobalStyleAttributes.fonts.standard16} boldFont>{t('qrNotificationLbl')}</AppText>
                    <CustomSwitch isChecked={isChecked} onToggle={toggle} style={{ width: isMobile && 'inherit' }} />
                </HStack>
                <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('qrNotificationTxt')}</AppText>
            </VStack>}
        </>
    );
};

export default QrNotification;
